import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PublicTools from '../pages/PublicTools';
import PomodoroTools from '../pages/PomodoroTools';
import TaskPrioritizerPage from '../pages/TaskPrioritizerPage';
import DopamenuPage from '../pages/DopamenuPage';
import { DopamenuProvider } from '../contexts/DopamenuContext';
import { FocusToolsProvider } from '../contexts/FocusToolsContext';
import FocusToolsOverlay from './FocusToolsOverlay';
import PublicToolsLayout from './PublicToolsLayout';

// Public tools share the top bar without mounting account-data providers.
export default function PublicToolsRouter({ children }) {
  return (
    <DopamenuProvider><FocusToolsProvider>
      <FocusToolsOverlay />
      <Routes>
        <Route path="/tools" element={<PublicToolsLayout />}>
          <Route index element={<PublicTools />} />
          <Route path="pomodoro" element={<PomodoroTools />} />
          <Route path="prioritize" element={<TaskPrioritizerPage />} />
          <Route path="dopamenu" element={<DopamenuPage />} />
        </Route>
        <Route path="*" element={children} />
      </Routes>
    </FocusToolsProvider></DopamenuProvider>
  );
}
